import { sortByIndex } from '../array';

export const transformItems = sortByIndex;
